import { MessagePageProps } from "./types";
import { StyledMessagePage } from "./style";

function MessagePage({
  headerText,
  headerColor,
  headerSize,
  text,
  textColor,
  textSize,
  fontFamily,
  children,
}: MessagePageProps) {
  return (
    <StyledMessagePage
      fontFamily={fontFamily}
      headerColorOne={headerColor.colorOne}
      headerColorTwo={headerColor.colorTwo || headerColor.colorOne}
    >
      <div className='container'>
        <h1 style={{ fontSize: `${headerSize}px` }}>{headerText}</h1>
        <h2 style={{ color: textColor, fontSize: `${textSize}px` }}>{text}</h2>
        {children}
      </div>
    </StyledMessagePage>
  );
}

export default MessagePage;
